import '../interaction_view.js.coffee'
Namespace 'Customer.Ticket'

class Customer.Ticket.WebchatStartInteractionView extends Customer.Ticket.InteractionView
  render: (avoidDuplications = true) ->
    super(avoidDuplications)
    @_renderWebchatHistory() if @_hasWebchatHistory()
    @

  _renderWebchatHistory: ->
    @$el.prepend @_webchatHistoryView().render().el

  _webchatHistoryView: ->
    new Customer.Ticket.WebchatHistoryView
      history: @model.webchatHistory()

  _hasWebchatHistory: ->
    @model.webchatHistory().length > 0
